<template>
  <div class="app-navbar-school__center lg5 md4">
    <span v-if="entity.entity_name" class="app-navbar-school__text" :style="{ color: '#ccc' }">
      {{ entity.entity_name }} &nbsp;
    </span>
    <va-button @click="clickSelectSchool" border-color="#d43d27" class="switch_school" target="_blank">
      Switch School
    </va-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      toastText: 'Unexpected error while retrieving list of schools',
      toastDuration: 2500,
      // toastIcon: 'fa-star-o',
      toastPosition: 'top-center',
      isToastFullWidth: false
    }
  },
  computed: {
    ...mapState({
      entity: state => state.user.selectedEntity
    })
  },
  methods: {
    ...mapActions({
      //getSchools: 'schools/getSchools',
      setSchool: 'schools/setSelectedSchool',
      getSelectedSchool: 'schools/getSelectedSchool'
    }),
    clickSelectSchool() {
      this.$router.push({ name: 'school-list' })
        // eslint-disable-next-line handle-callback-err
        .catch(err => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.switch_school {
  background: transparent !important;
  border: 1px solid #d43d27 !important;
  color: #d43d27 !important;
}
</style>